module.exports = __webpack_public_path__ + "static/type-hierarchy-dark-38cee2f02a261a18e9131bff4c29a6d5.svg";